// Skill (knowledge-base topic package) types — mirror app/models/skill.py.

export const SKILL_STATUSES = ["draft", "published", "archived"] as const;
export type SkillStatus = (typeof SKILL_STATUSES)[number];

export type DocumentStatus = "pending" | "processing" | "ready" | "failed";

/** knowledge: a searchable knowledge base; protocol: a guided exercise the
 * companion runs in the conversation (steps and pipelines live in code). */
export type SkillKind = "knowledge" | "protocol";

export interface Skill {
  id: string;
  kind?: SkillKind;
  name: string;
  description: string;
  instructions: string;
  icon: string;
  accentColor: string | null;
  sortOrder: number;
  status: SkillStatus;
  enabled: boolean;
  publishedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface SkillWithStats extends Skill {
  documentCount: number;
  readyDocumentCount: number;
  chunkCount: number;
}

export interface SkillDocument {
  id: string;
  skillId: string;
  filename: string;
  sourceType: "file" | "url";
  sourceUrl: string | null;
  contentType: string;
  sizeBytes: number;
  storagePath: string;
  status: DocumentStatus;
  error: string | null;
  chunkCount: number;
  uploadedBy: string;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface KnowledgeChunk {
  id: string;
  skillId: string;
  documentId: string;
  chunkIndex: number;
  heading: string;
  content: string;
}

export interface KnowledgeSearchResult {
  skillId: string;
  skillName: string;
  documentId: string;
  filename: string;
  heading: string;
  content: string;
  score: number;
}

export function emptySkill(): Skill {
  return {
    id: "",
    name: "",
    description: "",
    instructions: "",
    icon: "",
    accentColor: null,
    sortOrder: 0,
    status: "draft",
    enabled: true,
    publishedAt: null,
    createdAt: null,
    updatedAt: null,
  };
}
